import { useEffect } from 'react'

export const useScrollRestorationManual = () => {
	useEffect(() => {
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual'
		}
	}, [])
}
